<template>
  <v-tooltip top :color="config.textColor">
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        v-bind="attrs"
        v-on="on"
        class="mb-1"
        label
        :color="config.color"
        :text-color="config.textColor"
        small
      >
        {{ chip_label }}
      </v-chip>
    </template>
    <span>{{ tooltip_label }}</span>
  </v-tooltip>
</template>

<script>
import { content } from "../../config/scavenger_reports.js";

export default {
  name: "ChipsVT",
  props: {
    status: {
      type: String,
      required: true,
    },
    label: {
      required: false,
    },
    tooltip: {
      required: false,
    },
  },
  data: function () {
    return {
      config: null,
      chip_label: null,
      tooltip_label: null,
    };
  },
  created() {
    this.config = content.en50160_report_chips[this.status];
  },
  mounted() {
    this.label
      ? (this.chip_label = this.label)
      : (this.chip_label = this.config.label);

    this.tooltip
      ? (this.tooltip_label = this.tooltip)
      : (this.tooltip_label = this.config.tooltip);
  },
};
</script>
